import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { AiOutlineShoppingCart } from "react-icons/ai";

import {  useAppSelector } from "./Global/Store";
const DropDown : React.FC = () =>{
  const readCartQuantity = useAppSelector((state) => state.totalQuantity);
    return (
        <div>
            <Container>
            <DivTwo>
            <NavBars style={{textDecoration : "none" , color: "black"}}>
              <Link style={{textDecoration : "none" ,color: "black" ,}}  to="/">
               <h4 style={{marginBottom:"40px" }}>Home</h4>
              </Link>
              <Link style={{textDecoration : "none" ,color: "black"}} to="/product">
                <h4>Products</h4>
              </Link>
              <Link style={{textDecoration : "none" ,color: "black"}} to="/cart">
               <div style={{display:"flex" , alignItems:"center"}}>
              
            <Icon1 to="/cart">
            <h4 style={{marginRight:"5px"}}>Cart</h4> 
              <AiOutlineShoppingCart />

              <Count> {readCartQuantity}</Count>
             
            </Icon1>
            </div>
              </Link>
              <Link style={{textDecoration : "none" ,color: "black"}} to="/services">
                <h4>Purchases</h4>
              </Link>
            </NavBars>
          </DivTwo>
          <DivThree>
          {/* <button bg = "white" bd = "1px solid black" col = "black" bgh = " #00b7ff" colh = "white" to = "/signup">Sign Up</button> */}
          <button>Get Started</button>
          {/* <Button bg = "black" bd = "1px solid black" col = "white" bgh = "gray" colh = "black"  to = "/signin">Sign in</Button> */}
          </DivThree>
            </Container>
        </div>
    )
}

export default DropDown

const Container = styled.div`
width: 100%;
height: calc(100vh);
background-color: #ffffffae;
/* background-color: red; */
position: absolute;
position : fixed;
z-index: 1;
left: 0;
top: 90px;

backdrop-filter: blur(5px);


display: none;



@media screen and (min-width: 375px) and (max-width: 500px) {
    /* width: 250px; */
    display: flex;

  flex-direction: column;
  /* background-color: red; */
  width: 100%;
  }

`

// const DivFour = styled.div`
//   display: none;

//   @media screen and (max-width: 500px) {
//     display: flex;
//     justify-content: flex-end;
//     align-items: flex-end;
//   }
// `

const Icon1 = styled(Link)`
  /* margin-right: 5px; */
  /* background-color: blue; */
  color: #000000e6;
  cursor: pointer;
  font-weight: 500;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-left: 10px; */
  cursor: pointer;
  text-decoration: none;
width: 100%;
 
  h4{
    font-size: 17px;
    font-weight: 600;
  }
`;

const Count = styled.div`
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background-color: black;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
`;

// const Button = styled(Link)<{bg : string , bd : string , col: string , bgh: string , colh : string}>`
//   cursor: pointer;
//   transition: all 400ms ease-in-out;
//   width: 100px;
//   height: 30px;
//   border-radius: 10px;
//   background-color: ${(props) => props.bg};
//   border: ${(props)=> props.bd};
//   color : ${(props) => props.col};
//   margin-right: 10px;
//   text-decoration: none;
//   font-weight: bold;
//   display: flex;
//   justify-content: center;
//   align-items: center;

// z-index: 999999;

//   :hover {
//     background-color: ${(props) => props.bgh};
//     color:  ${(props)=> props.colh};
//   }

// `


const NavBars = styled.div`
display: flex;
justify-content: space-between;
width: 250px;
text-decoration: none;
z-index: 999999;
h4{
  color: black;
cursor: pointer;
transition: all 400ms ease-in-out;



:hover{
  transform: scale(0.99);
  color: #00b7ff;
  text-decoration: underline
  
  ;
}
}

@media screen and (max-width: 500px) {
  display: block;
}

`

const DivThree = styled.div`
display: flex;
button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 50px;
    background-color: black;
    color: white;
    cursor: pointer;
    font-weight: bold;
    transition: all ease-in-out 400ms;
    margin-top: 20px;
    border-radius: 2px;
    border: 1px solid black;
    transition: all 400ms ease-in-out;
    :hover {
      background-color: #0000005c;
      transform: scale(0.99);
    }
  }
@media screen and (max-width: 768px) {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

`


const DivTwo = styled.div`
display: flex;
width: 100%;
  justify-content: center;
  align-items: center;

`